import React, { useEffect, useState } from 'react';
import { Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import axios from "axios";
import {
  Button,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import { useMsal, useAccount } from "@azure/msal-react";
import { silentRequest } from "../../../../authConfig";
const API_URL = process.env.REACT_APP_API_URL


const SelectTemplates = ({ setCurrentStep, }) => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const history = useHistory()
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companySignature, setCompanySignature] = useState(null)

  useEffect(() => {
    pickThisTemplate(selectedTemplateConfirm)
    // eslint-disable-next-line 
  }, [])

  const [hoveredTemplateId, setHoveredTemplateId] = useState(null);
  const [selectedTemplateConfirm, setSelectedTemplateConfirm] = useState({
    "id": "82e31ec7-c590-491e-a750-04888ee154a1",
    "type": "receipt-taxinvoice",
    "imageData": "https://uatleceiptimages.blob.core.windows.net/templates/receipt-taxinvoice-000101.png",
    "styleId": "000101"
  });


  const [allTemplates, setAllTemplates] = useState([]);
  const selectedValue = "receipt-taxinvoice"
  const templatesPerPageFirst = 6; 
  const templatesPerPageOthers = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const [templates, setTemplates] = useState([]);

  const handleChangeDocumentType = (newTemplates) => {
    const newTotalTemplates = newTemplates.length;

    const newTotalPages = newTotalTemplates > 0
      ? Math.ceil((newTotalTemplates - templatesPerPageFirst) / templatesPerPageOthers) + 1
      : 1;

    if (currentPage > newTotalPages) {
      setCurrentPage(newTotalPages);
    } else if (currentPage < 1) {
      setCurrentPage(1);
    }

  };


  useEffect(() => {
    fetchData(selectedValue);

    // eslint-disable-next-line
  }, [selectedValue,]);


  const selectNewTemplate = (template) => {
    const formData = new FormData();

    if (companyLogo !== null || companySignature !== null) {

      if (companyLogo !== null) {
        setCompanyLogo(companyLogo);
        formData.append("logo", companyLogo);
      } else {
        setCompanyLogo(null);

      }

      if (companySignature !== null) {
        setCompanySignature(companySignature);
        formData.append("signature", companySignature);
      } else {

      }

    } else {
      setCompanyLogo(null);
      setCompanySignature(null);
    }

    setCurrentStep(2)
    history.push({
      pathname: "/boarding/templates/upload",
      state: {
        templates: template
      }
    })

  }


  const fetchData = async (selectedValue) => {
    try {
      setIsLoading(true);
      // containerCreate(selectedValue)

      let tokenResponse;
      try {
        tokenResponse = await instance.acquireTokenSilent({
          ...silentRequest,
          account: account,
        });
      } catch (error) {
        console.error("Error acquiring token: ", error);
        instance.acquireTokenRedirect(silentRequest);
        return;
      }

      console.log("selectedValue right now", selectedValue);

      const response = await axios.get(
        `${API_URL}/templates/examples?documentType=receipt-taxinvoice`,

        {
          headers: {
            Authorization: "Bearer " + tokenResponse.accessToken,
          }
        }
      );

      // const response = await axios.get(
      //   `http://localhost:7073/api/templates/examples?documentType=receipt-taxinvoice`,

      //   {
      //     headers: {
      //       Authorization: "Bearer " + tokenResponse.accessToken,
      //     }
      //   }
      // );


      console.log("response new list", response);

      const _templates = response.data.filter(
        (_template) => _template.styleId.slice(-2) === "01"
      );
      console.log("templates origin show up ", _templates);
      console.log("templates origin counting", _templates.length);
      handleChangeDocumentType(_templates);
      setTemplates(_templates);
      setAllTemplates(response.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };




  useEffect(() => {
    setAllTemplates(allTemplates || []);

    // eslint-disable-next-line
  }, [allTemplates]);


  const pickThisTemplate = (template) => {
    setSelectedTemplateConfirm(template)
    const formData = new FormData();
    if (companyLogo !== null || companySignature !== null) {

      if (companyLogo !== null) {
        // Use the correct field name 'logo' and set the file name as 'logo.png'
        setCompanyLogo(companyLogo);
        formData.append("logo", companyLogo);
      } else {
        setCompanyLogo(null);

      }

      if (companySignature !== null) {
        // Use the correct field name 'signature' and set the file name as 'signature.png'
        setCompanySignature(companySignature);
        formData.append("signature", companySignature);
      } else {
        setCompanySignature(null);
      }

    } else {
      setCompanyLogo(null);
      setCompanySignature(null);
    }

  }


  function ExtractNumberNameFromStyleId(styleId, t) {
    const cleanedNumber = styleId.replace(/^0+/, '');
    let result;

    if (cleanedNumber.length === 4) {
      const firstPart = cleanedNumber.slice(0, 2);
      const lastPart = cleanedNumber.slice(2);
      result = `${t("boarding.templateNo")} ${firstPart} ${t("boarding.color")} ${lastPart}`;
    } else if (cleanedNumber.length === 3) {
      const firstPart = cleanedNumber.slice(0, 1);
      const lastPart = cleanedNumber.slice(2);
      result = `${t("boarding.templateNo")} ${firstPart} ${t("boarding.color")}  ${lastPart}`;
    }

    return result;
  }



  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "auto",
          alignItems: "center",
          position: "relative",
          paddingTop: "0%",
          marginTop: "40px",
        }}
      >

        {isLoading ?
          <Spinner label={t("boarding.loading")} style={{ height: "300px", width: "100%" }} size="extra-large" ></Spinner> :
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px", maxWidth: "1200px", margin: "0 auto" }}>
              {templates.map((template, index) => (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    height: hoveredTemplateId === template.styleId ? "455px" : "455px",
                    border: hoveredTemplateId === template.styleId ? "2px solid #0078D4" : "1px solid #ddd",
                    borderRadius: "2px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setHoveredTemplateId(template.styleId)}
                  onMouseLeave={() => setHoveredTemplateId(null)}
                  onClick={() => {
                    selectNewTemplate(template);
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={template.imageData}
                      alt={`Template ${template.styleId}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div
                    style={{
                      backgroundColor: hoveredTemplateId === template.styleId ? "#0078D4" : "grey",
                      padding: "8px 12px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ fontSize: "14px", fontWeight: "bold", color: "white" }}>
                      {ExtractNumberNameFromStyleId(template.styleId, t)}
                    </span>
                    <Button appearance="secondary">{t("boarding.select")}</Button>
                  </div>
                </div>
              ))}
            </div>
          </>
        }
      </div>
    </>
  )
}

export default SelectTemplates
